//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const DisableUserLogin: FeatureFlag = {"Id":"DisableUserLogin","Label":"(Performance) Disable allowing users to login ","Impact":"Normally, visitor can login. When this is enabled, visitors can not login.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
